import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import {filter} from 'lodash';
import i18n from 'i18n';
import qs from 'query-string';

import {getStatics} from 'config/app';

import {SocialBadgeXL} from 'apps/shared/components';
import {connectFacebook, connectTwitter, connectInstagram, connectYoutube} from 'modules/legacy/js/lib/social-network-connections';
import InstagramAccountTypeSelector from 'modules/socialAccounts/influencer/screens/InstagramAccountTypeSelector';
import FacebookAccountTypeSelector from 'modules/socialAccounts/influencer/screens/FacebookAccountTypeSelector';
import {gotoPage} from '../actions/app';
import { getDefaultTitle } from 'config/app';
import ConectionDialog from 'apps/shared/components/TikTok/connectionDialog'; 
import LimitationList from 'apps/influencers/shared/components/LimitationList/LimitationsList';

const SocialNetworkButton = createClass({
  propTypes: {
    type: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func
  },

  render() {
    const {type, name, onClick} = this.props;

    return (
      <div
        style={{'border-radius': '1px'}}
        className='vf-btn flex flex-start'
        onClick={onClick}
        data-uitest={`social-network-button-${type}`}
      >
        <div className=' flex'>
          <SocialBadgeXL
            className='margin-right-1x'
            socialNetwork={type}
            style={{
              width: '5rem',
              height: '5rem',
              lineHeight: '5rem',
              borderRadius: '5rem'
            }}
          />
          <div
            style={{'font-size': '1.3em'}}
            className='vf-capitalize'
          >
            {name}
          </div>
        </div>
      </div>
    );
  }
});

const SettingsSocialConnectAccount = createClass({
  propTypes: {
    onAttempt: PropTypes.func,
    onRedirect: PropTypes.func,
    activeSocialNetworks: PropTypes.array
  },

  getDefaultProps() {
  },

  getInitialState() {
    return {customConnector: '',
            displaySocialNetworks: true};
  },

  customSocialNetworkConnectors: {
    instagram: InstagramAccountTypeSelector, 
    facebook: FacebookAccountTypeSelector
  },

  getCustomSocialNetworkConnector(socialNetwork) {
    const socialNetworkConnector = {
      instagram: () => this.setState({customConnector: 'instagram', displaySocialNetworks: false}), 
      facebook: () => this.setState({customConnector: 'facebook', displaySocialNetworks: false}), 
      tiktok: () => this.setState({customConnector: 'tiktok', displaySocialNetworks: true}),
    };
    return socialNetworkConnector[socialNetwork];
  },

  getDefaultActiveSocialNetworks() {
    const {socialNetworks} = getStatics();
    return filter(socialNetworks, (e, key) => {
      e.key = key;
      return e.active;
    }).map(sn => ({key: sn.key, name: sn.name}));
  },

  connectToSocialNetwork(socialNetwork, onRedirect, connections, redirectTo) {
    const customConnection = this.getCustomSocialNetworkConnector(socialNetwork);
    if (customConnection) return customConnection();
    const connect = connections[socialNetwork];
    const params = qs.stringify({redirectTo});
    connect({onRedirect, redirectTo})
      .then(() => gotoPage(`/social-accounts/add/facebook/pages?${params}`));
  },

  renderSocialNetworkButtons() {
    const {onRedirect, activeSocialNetworks, redirectTo} = this.props;
    const activeSN = activeSocialNetworks || this.getDefaultActiveSocialNetworks();
    const connections = {
      twitter: connectTwitter,
      instagram: connectInstagram,
      facebook: connectFacebook,
      youtube: connectYoutube, 
      tiktok: connectInstagram
    };

    const buttons = activeSN.map((socialNetwork) => {
      return (
        <div
          className='margin-bottom-1x col-xs-12 col-sm-6'
          id={socialNetwork.key}
          key={socialNetwork.key}
        >
          <SocialNetworkButton
            type={socialNetwork.key}
            name={socialNetwork.name}
            onClick={() => this.connectToSocialNetwork(socialNetwork.key, onRedirect, connections, redirectTo)}
          />
        </div>
      );
    });

    return (
      <div className='flex flex-wrap vf-row'>
        {buttons}
      </div>
    );
  },

  onBackCustomConnectorComponent() {
    this.setState({customConnector: null, displaySocialNetworks: true});
  },

  render() {
    const {customConnector, displaySocialNetworks} = this.state;
    const {onRedirect, wrapperStyle, redirectTo} = this.props;
    const CustomConnectorComponent = this.customSocialNetworkConnectors[customConnector];
    return (
      <div
        className='vf-wrapper vf-connect-account'
        id='link-social-account-panel'
        style={wrapperStyle}
      >
        <div className='vf-row '>
          <div className='col-xs-12'>
            <h3>{i18n.get('INF_SOCIAL_ACCOUNTS_LINK_SOCIAL_NETWORK')}</h3>

            {!CustomConnectorComponent && (
              <span className='vf-text-gray margin-vertical-1x'>
                {i18n.get('INF_SOCIAL_ACCOUNTS_LINK_NEW_REDIRECT_WARNING')}
              </span>
            )}

            {!CustomConnectorComponent && (
              <div
                className='flex middle-xs vf-border-warning-color vf-text-warning margin-vertical-1x padding-vertical-Hx padding-horizontal-1x'
                style={{fontSize: '1.5rem'}}
              >
                <i
                  className='vf-icon icon-exclamation-triangle margin-right-Hx'
                  style={{fontSize: '1.5rem', lineHeight: '1.5rem'}}
                />
                {i18n.get('INF_SOCIAL_ACCOUNTS_LINK_NEW_PRIVACY_DISCLAIMER',{companyName:getDefaultTitle()})}
              </div>
            )}
          </div>
        </div>

        <div className='vf-row'>
          <div className='col-xs-12 col-sm-12 col-lg-12'>
            {CustomConnectorComponent &&
              <CustomConnectorComponent
                onRedirect={onRedirect}
                redirectTo={redirectTo}
                onBack={this.onBackCustomConnectorComponent}
              />
            }
            {displaySocialNetworks && this.renderSocialNetworkButtons()}
          </div>
        </div>
        {
          displaySocialNetworks &&
          <LimitationList />
        }
        <ConectionDialog 
          isOpen = { customConnector === 'tiktok'}
          onClose = {this.onBackCustomConnectorComponent}
        />
      </div>
    );
  }
});

export default SettingsSocialConnectAccount;